// JS
import React from 'react';
import { renderHTML } from '../../shared/utils';

import Slider from '../../Slider';

const FeatureLayout = ({
  showFeatureLayout,
  featureLayoutOptions,
  uniqueId,
  data,
  gaBlockName,
  topMargin,
  lazyLoad = true
}) => {
  return (
    <section
      id={'editorial-' + uniqueId}
      className={
        showFeatureLayout
          ? (topMargin ? 'my-24' : 'mb-24') +
            (featureLayoutOptions?.classes
              ? ' ' + featureLayoutOptions.classes
              : '')
          : 'hidden'
      }
    >
      {data && (
        <div
          data-name={
            data[0]?.block_title +
            ' & ' +
            data[1]?.block_title +
            ' & ' +
            data[2]?.block_title
          }
          data-creative={gaBlockName}
          data-id={
            data[0]?.contentguid +
            '-&-' +
            data[1]?.contentguid +
            '-&-' +
            data[2]?.contentguid
          }
          data-position={'banner-slot-1'}
          data-type="banner"
        >
          <Slider
            name="editorial"
            usePagination={true}
            /*
            paginationOptions={{
              classes: {
                wrapper: 'xl:hidden'
              }
            }}
            */
            responsive={{
              sm: {
                show: 1,
                spaceBetween: 0
              },
              lg: {
                show: 2,
                spaceBetween: 12
              },
              '2xl': {
                show: 3
              }
            }}
          >
            {data.map((item, i) => {
              return (
                <a
                  key={item.contentguid}
                  href={item.url}
                  className="group flex h-full items-end aspect-[4/5] md:aspect-[11/12] bg-cover bg-center"
                  data-name={item.block_title + ' ' + item.block_sub_title}
                  data-creative={gaBlockName}
                  data-id={item.contentguid}
                  data-position={'button-slot-' + (i + 1)}
                  data-type="banner-button"
                >
                  <div className="absolute inset-0 z-[1] w-full h-full bg-gradient-to-t from-black/70" />
                  <img
                    src={item.icon}
                    alt=""
                    className="w-full h-full object-cover absolute inset-0 z-0"
                    loading={lazyLoad ? 'lazy' : 'eager'}
                  />
                  <div className="relative z-10 w-full mx-10 md:mx-14 my-10 md:my-8 text-white uppercase">
                    <h3 className="text-lg lg:text-xl mb-5 lg:mb-8 xl:group-hover:-translate-y-8 transition-all duration-400">
                      <div className="pr-1.5 font-semibold">
                        {item.block_title}
                      </div>
                      {item.block_sub_title}
                    </h3>
                    {renderHTML(item.block_description, 'text-sm')}
                  </div>
                </a>
              );
            })}
          </Slider>
        </div>
      )}
    </section>
  );
};

export default FeatureLayout;
